module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "calibre1",
    attrs: {
      "id": "filepos1804"
    }
  }, [_c('span', {
    staticClass: "calibre2"
  }, [_c('img', {
    staticClass: "calibre3",
    attrs: {
      "alt": "images",
      "src": "Images/00001.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "calibre4"
  }), _vm._v(" "), _c('p', {
    staticClass: "calibre5"
  }, [_c('a', {
    staticClass: "calibre6",
    attrs: {
      "href": "#/Text/3_Beautiful_or_all_Reasons_split_001#filepos5355"
    }
  }, [_c('span', {
    staticClass: "underline bold"
  }, [_vm._v("Getting Started")])])]), _vm._v(" "), _c('p', {
    staticClass: "calibre5"
  }, [_c('a', {
    staticClass: "calibre6",
    attrs: {
      "href": "#/Text/3_Beautiful_or_all_Reasons_split_001#filepos5355"
    }
  }, [_c('span', {
    staticClass: "underline bold"
  }, [_vm._v("Basic Equipment")])])]), _vm._v(" "), _c('p', {
    staticClass: "calibre5"
  }, [_c('a', {
    staticClass: "calibre6",
    attrs: {
      "href": "#/Text/3_Beautiful_or_all_Reasons_split_002#filepos11881"
    }
  }, [_c('span', {
    staticClass: "underline bold"
  }, [_vm._v("The Sewing Machine")])])]), _vm._v(" "), _c('p', {
    staticClass: "calibre5"
  }, [_c('a', {
    staticClass: "calibre6",
    attrs: {
      "href": "#/Text/3_Beautiful_or_all_Reasons_split_003#filepos17507"
    }
  }, [_c('span', {
    staticClass: "underline bold"
  }, [_vm._v("Using Patterns")])])]), _vm._v(" "), _c('p', {
    staticClass: "calibre5"
  }, [_c('a', {
    staticClass: "calibre6",
    attrs: {
      "href": "#/Text/3_Beautiful_or_all_Reasons_split_004#filepos21523"
    }
  }, [_c('span', {
    staticClass: "underline bold"
  }, [_vm._v("Modifying Patterns")])])]), _vm._v(" "), _c('p', {
    staticClass: "calibre5"
  }, [_c('a', {
    staticClass: "calibre6",
    attrs: {
      "href": "#/Text/3_Beautiful_or_all_Reasons_split_005#filepos24362"
    }
  }, [_c('span', {
    staticClass: "underline bold"
  }, [_vm._v("Understanding Patterns")])])]), _vm._v(" "), _c('p', {
    staticClass: "calibre5"
  }, [_c('a', {
    staticClass: "calibre6",
    attrs: {
      "href": "#/Text/3_Beautiful_or_all_Reasons_split_006#filepos31667"
    }
  }, [_c('span', {
    staticClass: "underline bold"
  }, [_vm._v("Fabric Types")])])]), _vm._v(" "), _c('p', {
    staticClass: "calibre5"
  }, [_c('a', {
    staticClass: "calibre6",
    attrs: {
      "href": "#/Text/3_Beautiful_or_all_Reasons_split_007#filepos36837"
    }
  }, [_c('span', {
    staticClass: "underline bold"
  }, [_vm._v("Fabric Preparation and Cutting")])])]), _vm._v(" "), _c('p', {
    staticClass: "calibre5"
  }, [_c('a', {
    staticClass: "calibre6",
    attrs: {
      "href": "#/Text/3_Beautiful_or_all_Reasons_split_008#filepos44059"
    }
  }, [_c('span', {
    staticClass: "underline bold"
  }, [_vm._v("Techniques")])])]), _vm._v(" "), _c('p', {
    staticClass: "calibre5"
  }, [_c('a', {
    staticClass: "calibre6",
    attrs: {
      "href": "#/Text/3_Beautiful_or_all_Reasons_split_008#filepos44059"
    }
  }, [_c('span', {
    staticClass: "underline bold"
  }, [_vm._v("Flush Zip Pocket")])])]), _vm._v(" "), _c('p', {
    staticClass: "calibre5"
  }, [_c('a', {
    staticClass: "calibre6",
    attrs: {
      "href": "#/Text/3_Beautiful_or_all_Reasons_split_009#filepos54753"
    }
  }, [_c('span', {
    staticClass: "underline bold"
  }, [_vm._v("Top Edge Zip")])])]), _vm._v(" "), _c('p', {
    staticClass: "calibre5"
  }, [_c('a', {
    staticClass: "calibre6",
    attrs: {
      "href": "#/Text/3_Beautiful_or_all_Reasons_split_010#filepos62246"
    }
  }, [_c('span', {
    staticClass: "underline bold"
  }, [_vm._v("Slimline Concealed Top Edge Zip")])])]), _vm._v(" "), _c('p', {
    staticClass: "calibre5"
  }, [_c('a', {
    staticClass: "calibre6",
    attrs: {
      "href": "#/Text/3_Beautiful_or_all_Reasons_split_011#filepos73048"
    }
  }, [_c('span', {
    staticClass: "underline bold"
  }, [_vm._v("Magnetic Snaps")])])]), _vm._v(" "), _c('p', {
    staticClass: "calibre5"
  }, [_c('a', {
    staticClass: "calibre6",
    attrs: {
      "href": "#/Text/3_Beautiful_or_all_Reasons_split_012#filepos76861"
    }
  }, [_c('span', {
    staticClass: "underline bold"
  }, [_vm._v("Open-End Straps")])])]), _vm._v(" "), _c('p', {
    staticClass: "calibre5"
  }, [_c('a', {
    staticClass: "calibre6",
    attrs: {
      "href": "#/Text/3_Beautiful_or_all_Reasons_split_013#filepos81231"
    }
  }, [_c('span', {
    staticClass: "underline bold"
  }, [_vm._v("Closed-End Straps")])])]), _vm._v(" "), _c('p', {
    staticClass: "calibre5"
  }, [_c('a', {
    staticClass: "calibre6",
    attrs: {
      "href": "#/Text/3_Beautiful_or_all_Reasons_split_014#filepos85830"
    }
  }, [_c('span', {
    staticClass: "underline bold"
  }, [_vm._v("Adjustable Straps")])])]), _vm._v(" "), _c('p', {
    staticClass: "calibre5"
  }, [_c('a', {
    staticClass: "calibre6",
    attrs: {
      "href": "#/Text/3_Beautiful_or_all_Reasons_split_015#filepos89683"
    }
  }, [_c('span', {
    staticClass: "underline bold"
  }, [_vm._v("Bound Edges")])])]), _vm._v(" "), _c('p', {
    staticClass: "calibre5"
  }, [_c('a', {
    staticClass: "calibre6",
    attrs: {
      "href": "#/Text/3_Beautiful_or_all_Reasons_split_016#filepos95735"
    }
  }, [_c('span', {
    staticClass: "underline bold"
  }, [_vm._v("Piped Edges")])])]), _vm._v(" "), _c('p', {
    staticClass: "calibre5"
  }, [_c('a', {
    staticClass: "calibre6",
    attrs: {
      "href": "#/Text/3_Beautiful_or_all_Reasons_split_017#filepos103493"
    }
  }, [_c('span', {
    staticClass: "underline bold"
  }, [_vm._v("Inserting Linings: Pull Through and Turn Out Method")])])]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "calibre2"
  }, [_c('img', {
    staticClass: "calibre3",
    attrs: {
      "alt": "images",
      "src": "Images/00002.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "calibre4"
  }), _vm._v(" "), _c('p', {
    staticClass: "calibre5"
  }, [_c('a', {
    staticClass: "calibre6",
    attrs: {
      "href": "#/Text/3_Beautiful_or_all_Reasons_split_018#filepos108907"
    }
  }, [_c('span', {
    staticClass: "underline bold"
  }, [_vm._v("The Compact Groceries Tote")])])]), _vm._v(" "), _c('p', {
    staticClass: "calibre5"
  }, [_c('a', {
    staticClass: "calibre6",
    attrs: {
      "href": "#/Text/3_Beautiful_or_all_Reasons_split_019#filepos128724"
    }
  }, [_c('span', {
    staticClass: "underline bold"
  }, [_vm._v("The Fashionista Baby Bag")])])]), _vm._v(" "), _c('p', {
    staticClass: "calibre5"
  }, [_c('a', {
    staticClass: "calibre6",
    attrs: {
      "href": "#/Text/3_Beautiful_or_all_Reasons_split_020#filepos162381"
    }
  }, [_c('span', {
    staticClass: "underline bold"
  }, [_vm._v("The Fashionista Changing Mat")])])]), _vm._v(" "), _c('p', {
    staticClass: "calibre5"
  }, [_c('a', {
    staticClass: "calibre6",
    attrs: {
      "href": "#/Text/3_Beautiful_or_all_Reasons_split_021#filepos179645"
    }
  }, [_c('span', {
    staticClass: "underline bold"
  }, [_vm._v("The Fashionista Shoulder Strap Pad")])])]), _vm._v(" "), _c('p', {
    staticClass: "calibre5"
  }, [_c('a', {
    staticClass: "calibre6",
    attrs: {
      "href": "#/Text/3_Beautiful_or_all_Reasons_split_022#filepos187832"
    }
  }, [_c('span', {
    staticClass: "underline bold"
  }, [_vm._v("The 3-in-1 Convertible Backpack")])])]), _vm._v(" "), _c('p', {
    staticClass: "calibre7"
  }, [_c('a', {
    staticClass: "calibre6",
    attrs: {
      "href": "#/Text/3_Beautiful_or_all_Reasons_split_023#filepos232525"
    }
  }, [_c('span', {
    staticClass: "underline bold"
  }, [_vm._v("Templates")])])]), _vm._v(" "), _c('div', {
    staticClass: "mbppagebreak",
    attrs: {
      "id": "calibre_pb_0"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1c338148","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/3_Beautiful_-or_all_Reasons_split_000.vue
// module id = 57
// module chunks = 0